<template>
    <button type="button" tabindex="2" class="btn waves-effect text-left" v-bind="$attrs" :disabled="process" :class="process?'load':''">
        <span><slot></slot></span>
        <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"></circle> 
        </svg>
    </button>
</template>

<script>
    export default {
        name:"button",
        props:{
            title:String,
            process:Boolean
        }
    }
</script>

<style>

</style>